import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_DataFile() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders, handlePresignedUrlDownload } =
    API_Calls_Utils();

  const getUploads = async (affiliate) => {
    const { headers, queryString } = await queryParamsAndHeaders({ affiliate });

    return apiCall({
      url: `${backendUrl}/api/uploads?${queryString}`,
      headers,
    });
  };

  const getUploadColumns = async (
    affiliate,
    filename,
    created,
    data_source = "membership"
  ) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      filename,
      created,
      data_source,
    });
    return apiCall({
      url: `${backendUrl}/api/uploads/columns?${queryString}`,
      headers,
    });
  };

  const uploadFile = async (affiliate, file, onUploadProgress) => {
    const { headers, queryString } = await queryParamsAndHeaders(
      { affiliate },
      null,
      true
    );

    const formData = new FormData();
    formData.append("file", file, file.name);

    return apiCall({
      url: `${backendUrl}/api/uploads?${queryString}`,
      method: "POST",
      data: formData,
      headers,
      onUploadProgress,
    });
  };

  const downloadFile = async (affiliate, filename, created) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      filename,
      created,
    });

    const url = `${backendUrl}/api/download?${queryString}`;
    return handlePresignedUrlDownload(url, headers);
  };

  const deleteUpload = async (affiliate, filename, created) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      filename,
      created,
    });

    return apiCall({
      url: `${backendUrl}/api/uploads?${queryString}`,
      method: "DELETE",
      headers,
    });
  };

  return {
    getUploads,
    getUploadColumns,
    uploadFile,
    downloadFile,
    deleteUpload,
  };
}
